import GetStudio from './GetStudio';

export default GetStudio;
